<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Scrollable Content Area -->
<div class="modal-scrollable-content" [hidden]="minimise">

<!-- Loader -->
@if (loading) {
<div class="modal-loader">
  <i class="fa fa-spinner fa-spin fa-3x"></i>
</div>
}

<!-- ADD_GROUP and GROUP_EDIT Form - only show for these specific modes -->
@if (!loading && (colDataMap === 'ADD_GROUP' || colDataMap === 'GROUP_EDIT')) {
<div>
  <form name="ftr_consol_form" novalidate autocomplete="off">
    <div class="modal-body no-body-scroll">
      <div class="form-horizontal">
        
        <!-- Fiscal Start -->
        <div class="form-group row">
          <label for="fiscal_start" class="col-sm-3 control-label">Fiscal Start:</label>
          <div class="col-sm-5">
            <select id="fiscal_start" 
                    name="fiscal_start" 
                    class="form-control"
                    [(ngModel)]="selectedFiscalStart"
                    [compareWith]="compareDropdown"
                    (ngModelChange)="changeFiscalStart()"
                    required 
                    [disabled]="disabled">
              <option [ngValue]="null">Select</option>
              @for (taxLoop of tax_year_list; track $index) {
<option [ngValue]="taxLoop">
                {{taxLoop.TAX_YEAR}}
              </option>
}
            </select>
            @if (!selectedFiscalStart && isSaveClicked) {
<span class="form-error-container">
              <span>Fiscal Start is required.</span>
            </span>
}
          </div>
        </div>

        <!-- Fiscal End -->
        <div class="form-group row">
          <label for="fiscal_end" class="col-sm-3 control-label">Fiscal End:</label>
          <div class="col-sm-5">
            <select id="fiscal_end" 
                    name="fiscal_end" 
                    class="form-control"
                    [(ngModel)]="selectedFiscalEnd"
                    [compareWith]="compareDropdown"
                    (ngModelChange)="changeFiscalEnd()"
                    required>
              <option [ngValue]="null">Select</option>
              @for (taxLoop of tax_year_list; track $index) {
<option [ngValue]="taxLoop">
                {{taxLoop.TAX_YEAR}}
              </option>
}
            </select>
            @if (!selectedFiscalEnd && isSaveClicked) {
<span class="form-error-container">
              <span>Fiscal End is required.</span>
            </span>
}
            @if (selectedFiscalEnd && selectedFiscalStart && selectedFiscalEnd.TAX_YEAR < selectedFiscalStart.TAX_YEAR) {
<span class="form-error-container" 
                 >
              <span>Fiscal Year End cannot be less than fiscal start year.</span>
            </span>
}
          </div>
        </div>

        <!-- LEID for head of group -->
        <div class="form-group row">
          <label for="gold_group_head" class="col-sm-3 control-label">LEID for head of group:</label>
          <div class="col-sm-5">
            @if (colDataMap !== 'GROUP_EDIT') {
<select 
                    id="gold_group_head" 
                    name="gold_group_head" 
                    class="form-control"
                    [(ngModel)]="selectedHeadLeid"
                    required 
                    [disabled]="disabled">
              <option [ngValue]="null">Select</option>
              @for (leid of gold_head_leid_list; track $index) {
<option [ngValue]="leid">
                {{leid.DISPLAY_VAL}}
              </option>
}
            </select>
}
            @if (colDataMap === 'GROUP_EDIT') {
<input 
                   type="text" 
                   id="gold_group_head" 
                   name="gold_group_head"
                   class="form-control"
                   [ngModel]="rowData?.GROUP_LEID"
                   readonly
                   [disabled]="disabled">
}
            @if (colDataMap !== 'GROUP_EDIT' && !selectedHeadLeid && isSaveClicked) {
<span class="form-error-container">
              <span>LEID for head of group is required.</span>
            </span>
}
          </div>
        </div>

        <!-- Group Name -->
        <div class="form-group row">
          <label for="group_name" class="col-sm-3 control-label">Group Name:</label>
          <div class="col-sm-5">
            <input type="text" 
                   class="form-control" 
                   id="group_name" 
                   name="group_name" 
                   [(ngModel)]="GROUP_NAME" 
                   required>
            @if ((!GROUP_NAME || GROUP_NAME.trim() === '') && isSaveClicked) {
<span class="form-error-container">
              <span>Group Name is required.</span>
            </span>
}
          </div>
        </div>

        <!-- Group Type -->
        <div class="form-group row">
          <label for="group_type" class="col-sm-3 control-label">Group Type:</label>
          <div class="col-sm-5">
            <div class="cge-radio-group">
              <label class="cge-radio-label">
                <input type="radio" 
                       name="rd_group_type" 
                       id="rd_group_type_consol" 
                       value="CH" 
                       [(ngModel)]="GROUP_TYPE"> Consolidated
              </label>
              <label class="cge-radio-label">
                <input type="radio" 
                       name="rd_group_type" 
                       id="rd_group_type_gr" 
                       value="GH" 
                       [(ngModel)]="GROUP_TYPE"> Group Relief
              </label>
            </div>
          </div>
        </div>

        <!-- Currency -->
        <div class="form-group row">
          <label for="currency" class="col-sm-3 control-label">Currency:</label>
          <div class="col-sm-5">
            <select id="currency" 
                    name="currency" 
                    class="form-control"
                    [(ngModel)]="selectedCurrency"
                    required>
              <option [ngValue]="null">Select</option>
              @for (curr of currency_list; track $index) {
<option [ngValue]="curr">
                {{curr.CURR_DISPLAY_FTR}}
              </option>
}
            </select>
            @if (!selectedCurrency && isSaveClicked) {
<span class="form-error-container">
              <span>Currency is required.</span>
            </span>
}
          </div>
        </div>

        <!-- US Tax Owner -->
        <div class="form-group row">
          <label for="us_tax_owner" class="col-sm-3 control-label">US Tax Owner:</label>
          <div class="col-sm-5">
            <select id="us_tax_owner" 
                    name="us_tax_owner" 
                    class="form-control"
                    [(ngModel)]="selectedTaxOwner"
                    [compareWith]="compareTaxOwner"
                    required>
              <option [ngValue]="null">Select</option>
              @for (taxOwner of taxOwnersList; track $index) {
<option [ngValue]="taxOwner">
                {{taxOwner.FULL_NAME}}
              </option>
}
            </select>
            @if (!selectedTaxOwner && isSaveClicked) {
<span class="form-error-container">
              <span>US Tax Owner is required.</span>
            </span>
}
          </div>
        </div>
        
      </div>
    </div>
  </form>
</div>
}

<!-- MEMBERS_EDIT and ALLOCATE_LIABILITY Info Display -->
@if (!loading && (colDataMap === 'MEMBERS_EDIT' || colDataMap === 'ALLOCATE_LIABILITY')) {
<div 
     class="group-info-section">
  <div class="info-row">
    <label><strong>LEID for head of group:</strong></label>
    <span>{{rowData?.GROUP_LEID}}</span>
  </div>
  <div class="info-row">
    <label><strong>Group Name:</strong></label>
    <span>{{GROUP_NAME}}</span>
  </div>
  <div class="info-row">
    <label><strong>Group Currency:</strong></label>
    <span>{{rowData?.CURRENCY}}</span>
  </div>
  <div class="info-row">
    <label><strong>Fiscal Year:</strong></label>
    <span>{{filter_tax_year}}</span>
  </div>
</div>
}

<!-- ALLOCATE_LIABILITY Section -->
@if (!loading && colDataMap === 'ALLOCATE_LIABILITY') {
<div 
     class="allocate-liability-section">
  
  <!-- Date Filed -->
  <div class="date-filed-row">
    <label for="dateFiled">Date filed:</label>
    <div class="input-group">
      <input type="date" 
             class="form-control" 
             id="dateFiled"
             [value]="dateFiledString"
             (change)="onDateFiledChange($any($event.target).value)">
    </div>
  </div>
  
  <!-- Allocation Table -->
  <div class="table-responsive">
    <table id="tblAllocLiability" class="table table-bordered custom-table">
      <thead>
        <tr>
          <th style="text-align: center;">LEID</th>
          <th style="text-align: center;">Legal Entity Name</th>
          <th style="text-align: center;">Country</th>
          <th style="text-align: center;">Tax on Income(Creditable for US)</th>
          <th style="text-align: center;">Tax on Assets or Capital(Non-Creditable for US)</th>
        </tr>
      </thead>
      <tbody>
        @for (rec of membersAmountList; track $index) {
<tr>
          <td style="text-align:center">{{rec.LEID}}</td>
          <td style="text-align:center">{{rec.LE_NAME}}</td>
          <td style="text-align:center">{{rec.COUNTRY_NAME}}</td>
          <td style="text-align:center">
            <input type="number" 
                   class="form-control input-sm"
                   [ngModel]="credit_us_amt[rec.COMBINATION_KEY]"
                   (ngModelChange)="credit_us_amt[rec.COMBINATION_KEY] = $event; setTotal()"
                   style="text-align:right">
          </td>
          <td style="text-align:center">
            <input type="number" 
                   class="form-control input-sm"
                   [ngModel]="non_credit_us_amt[rec.COMBINATION_KEY]"
                   (ngModelChange)="non_credit_us_amt[rec.COMBINATION_KEY] = $event; setTotal()"
                   style="text-align:right">
          </td>
        </tr>
}
      </tbody>
      <tfoot>
        <tr>
          <td style="text-align:center"></td>
          <td style="text-align:center"><strong>Total Tax Liability per Tax Return(s)</strong></td>
          <td style="text-align:center"></td>
          <td style="text-align:center">
            <input type="number" 
                   class="form-control input-sm"
                   [ngModel]="credit_us_amt_total"
                   disabled
                   style="text-align:right">
          </td>
          <td style="text-align:center">
            <input type="number" 
                   class="form-control input-sm"
                   [ngModel]="non_credit_us_amt_total"
                   disabled
                   style="text-align:right">
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
}

<!-- MEMBERS_EDIT Section -->
@if (!loading && colDataMap === 'MEMBERS_EDIT') {
<div 
     class="members-edit-section">
  
  <!-- Country Selection -->
  <div class="form-horizontal">
    <div class="form-group row">
      <label for="group_country" class="col-sm-3 control-label">Country:</label>
      <div class="col-sm-3">
        <select id="group_country" 
                name="group_country" 
                class="form-control"
                [(ngModel)]="selectedGroupCountry"
                (ngModelChange)="changeCountry()"
                required>
          <option [ngValue]="null">Select</option>
          @for (country of countryList; track $index) {
<option [ngValue]="country">
            {{country.LABEL}}
          </option>
}
        </select>
      </div>
    </div>
  </div>
  
  <!-- Dual List for Members Management -->
  <div class="members-dual-list">
    <!-- Non-Member List -->
    <div class="member-panel">
      <div class="panel panel-default">
        <div class="panel-heading">Non-Member List: {{nonMembersList?.length || 0}}</div>
        <div class="panel-body">
          @if (!nonMemerLoading && nonMembersList && nonMembersList.length > 0) {
<div>
            @for (item of nonMembersList; track $index) {
<div class="member-item">
              <i class="glyphicon glyphicon-plus-sign add-icon" 
                 (click)="addMembers(item)"></i>
              <span>{{item.DISPLAY_VAL}}</span>
            </div>
}
          </div>
}
          @if (!nonMemerLoading && (!nonMembersList || nonMembersList.length === 0)) {
<div>
            <p>No members found for the country {{selectedGroupCountry?.LABEL}}</p>
          </div>
}
          @if (nonMemerLoading) {
<div>
            <i class="fa fa-spinner fa-pulse"></i>
          </div>
}
        </div>
      </div>
    </div>
    
    <!-- Member List -->
    <div class="member-panel">
      <div class="panel panel-default">
        <div class="panel-heading">Member List: {{membersList?.length || 0}}</div>
        <div class="panel-body">
          @for (item of membersList; track $index) {
<div class="member-item">
            <i class="glyphicon glyphicon-remove-sign remove-icon" 
               (click)="removeMembers(item)"></i>
            <span>{{item.DISPLAY_VAL}}</span>
          </div>
}
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- US_TAX_OWNER Form - only show for US_TAX_OWNER mode -->
@if (!loading && colDataMap === 'US_TAX_OWNER') {
<div>
  <form name="ftr_consol_form_2" novalidate autocomplete="off">
    <div class="modal-body">
      <div class="form-horizontal">
        <div class="form-group row">
          <label for="us_tax_owner_edit" class="col-sm-3 control-label">US Tax Owner:</label>
          <div class="col-sm-6">
            <select id="us_tax_owner_edit" 
                    name="us_tax_owner_edit" 
                    class="form-control"
                    [(ngModel)]="selectedTaxOwner"
                    [compareWith]="compareTaxOwner"
                    required>
              <option [ngValue]="null">Select</option>
              @for (taxOwner of taxOwnersList; track $index) {
<option [ngValue]="taxOwner">
                {{taxOwner.FULL_NAME}}
              </option>
}
            </select>
            @if (!selectedTaxOwner && isSaveClicked) {
<span class="form-error-container">
              <span>US Tax Owner is required.</span>
            </span>
}
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
}

</div><!-- end .modal-scrollable-content -->

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="crudLoading"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
